export enum RolesEnum {
  "Administrator" = 1,
  "StoreOwner" = 2,
  "StoreUser" = 3,
  "AgencyOwner" = 4,
  "Agent" = 5,
  "CustomerOwner" = 6,
  "Customer" = 7,
  "Service" = 8,
  "Designer" = 10,
  "CustomerGuest" = 11,
}
